import UploadManagerProgressReportItem from "./UploadManagerProgressReportItem";

class UploadManagerProgressReport {
  public progressGlobal: number = 0;

  constructor(
    public totalChunksGlobal: number,
    public uploadedChunksGlobal: number,
    public progressByIdentifier: UploadManagerProgressReportItem[]
  ) {
    if (totalChunksGlobal > 0) {
      this.progressGlobal = Math.floor(
        (uploadedChunksGlobal * 100) / totalChunksGlobal
      );
    }
  }
}

export default UploadManagerProgressReport;
